
<template>
  <div>
    <span class="td-btn-content _alignmiddle mr-1">
      <img
        v-if="getpermission.inspect[1] == '1'"
        class="arbtn"
        src="https://i.imgur.com/cWUqqLH.gif"
        @click="fixOddsPerson(1,table.odddtl,table.troddid,table.trodds)"
      />
      <span
        class="td-btn-content-span"
        @click="showModal(table.odddtl, table.troddid, table.trodds)"
      >{{ strip(table.trodds) }}</span>
      <span
        v-if="table.trodds2 && getliveshow.isdoubleOdds == '0'"
        class="td-btn-content-span"
        @click="showModal(table.odddtl, table.troddid, table.trodds)"
      >{{ strip(table.trodds2) }}</span>
      <img
        v-if="getpermission.inspect[1] == '1'"
        class="arbtn"
        src="https://i.imgur.com/04cGLwd.gif"
        @click="fixOddsPerson(0,table.odddtl,table.troddid,table.trodds)"
      />
    </span>
    <span v-if="table.trodds2 && getliveshow.isdoubleOdds == '1'" class="td-btn-content _alignmiddle">
      <img
        v-if="getpermission.inspect[1] == '1'"
        class="arbtn"
        src="https://i.imgur.com/cWUqqLH.gif"
        @click="fixOddsPerson(1,table.odddtl2,table.troddid2,table.trodds2)"
      />
      <span
        class="td-btn-content-span"
        @click="showModal(table.odddtl2, table.troddid2, table.trodds2)"
      >{{ strip(table.trodds2) }}</span>
      <img
        v-if="getpermission.inspect[1] == '1'"
        class="arbtn"
        src="https://i.imgur.com/04cGLwd.gif"
        @click="fixOddsPerson(0, table.odddtl2, table.troddid2, table.trodds2)"
      />
    </span>
    <p>
      <p
       class="adjust-betting-list"
        v-if="betcallistshow"
      >{{  Math.round(table.ltl) | commaFormat }}</p>
    </p>
    <p>
      <p
        v-if="addbetcal"
        :class="table.realcal1 > 0 ? 'pc2':'pc1'"
      >{{  Math.round(table.realcal1) | commaFormat }}</a>
    </p>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import checkpath from 'views/liveshow/mixins/checkPath'
// import AlertNotice from "@/components/common/AlertNotice"
import NP from 'number-precision'
export default {
  name: 'livshow-adjust-odds',
  mixins: [checkpath],
  // components: {
  //    AlertNotice
  // },
  props: {
    table: {
      type: Object,
      default: () => ({
        trodds: null,
        ltl: 0,
        realcal1: 0,
        odddtl: 0,
        troddid: 0
      })
    },
    betcallistshow: {
      type: Boolean,
      default: true
    },
    addbetcal: {
      type: Boolean,
      default: true
    },
    isLinkage: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapGetters(["getliveshow", "getmember", "getpermission", "getgameid"])
  },
  methods: {
    ...mapActions(["chg_liveshow_state", "changeloading"]),
    showModal (odddtl, troddid, trodds) {
      if(this.getpermission.inspect[1] != '1') return
      this.$Eventhub.$emit("modify-liveshow-input-odds", {
        name: this.table.name,
        odddtl,
        troddid,
        trodds
      });
    },
    fixOddsPerson (porn, odddtl, troddid, trodds) {
      const ConfirmSpacing = porn === 0 // 取得修改後的倍率值
        ? NP.minus(trodds, this.getliveshow.default_chodd)
        : NP.plus(trodds, this.getliveshow.default_chodd)
      if (ConfirmSpacing < 1) return this.$Message.error({ content: '赔率不可低于 1' })
      const defaultData = {
        chodd: this.getliveshow.default_chodd,
        odddtl: odddtl,
        troddid: troddid,
        trodds: trodds,
        porn: porn,
        baco: this.getliveshow.chgbaco,
        loid: this.getmember.pid,
      }
      const liveshow = 
        this.liveshowPath
          ? { mlevel: this.getmember.mlevel, reppid: '1' }
          : { stid: this.getliveshow.siteSelect, sp99: ['liveshowAll-scode'].includes(this.$route.name) && this.getliveshow.tema == 1 ? 1 : 0 }
      let data = Object.assign(defaultData, liveshow)
      if ([10, 11, 14, 15].includes(odddtl)) data['isIND'] = this.getliveshow.isdoubleOdds
      if (this.getliveshow.siteSelect == '') return
      this.PostfixOdds(data)
    },
    async PostfixOdds (data) {
      try {
          let gameid = this.getgameid
          if (this.isLinkage) {
            if ([1, 225].includes(this.getgameid)) gameid = '1,225'
            if ([14, 226].includes(this.getgameid)) gameid = '14,226'
            if ([15, 227].includes(this.getgameid)) gameid = '15,227'
            if ([78, 228].includes(this.getgameid)) gameid = '78,228'
            if ([210, 224].includes(this.getgameid)) gameid = '210,224'
            if ([213, 229].includes(this.getgameid)) gameid = '213,229'
          }
          const res = this.liveshowPath 
            ? await this.$axios.liveshow.fixBacoOddsPerson(this.getgameid, data)
            : await this.$axios.liveshow.linksupododup(gameid, data)
          if(Array.isArray(res) && res[0].state == 0) {
          this.$Message.warning(res[0].msg)
          this.modalshow = !this.modalshow
          this.StatusfixOdds([])
        } else {
          if (res.status == 1) {
            const item = Object.keys(res).filter(it => it != 'status').map(it => res[it])
            this.StatusfixOdds(item)
          }
        }
      } catch (error) {
        // const index = this.liveshowPath ? 1 : 2
        // this.$Message.error(`网路异常：(S310${index})`);
      }
    },
    get_betcallist (odddtl, troddid) {
      if(this.liveshowAllPath || this.getpermission.indata[0] != '1') return
      const logid = { gameid: this.getgameid, logid: this.getmember.pid }
      const data = Object.assign({}, this.table, logid)
      this.$axios.liveshow.CloseBettingList(data).then(res => {
        this.chg_liveshow_state({ modal_show:true, moddata: res });
      });
    },
    StatusfixOdds (item) {
      this.$Eventhub.$emit('alert-notice', item)
      this.$Eventhub.$emit('liveshow-refresh')
    },
    alertClass (val) {
      if(val.state == null) return { 'lida-card-alert error': true }
      return val.state.status === 1 
        ? { 'lida-card-alert success': true }
        : { 'lida-card-alert warning': true }
    }
  }
};
</script>

<style lang="scss" scoped>
.td-btn-content {
  .td-btn-content-span {
    padding: 0 2px;
    cursor: pointer;
  }
  .td-btn-content-span,
  img {
    display: inline-block;
    vertical-align: middle;
  }
}
.title-cell-class-name-test1 {
  background-color: #2db7f5;
  color: #fff;
}
.title-cell-class-name-test2 {
  background-color: #f60;
  color: #fff;
}
a.adjust-betting-list[disabled] {
  color: #5c5c5c;
}

</style>